/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Again_ButtonInputs */

const en_try_again_button = /** @type {(inputs: Try_Again_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const nl_try_again_button = /** @type {(inputs: Try_Again_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer het opnieuw`)
};

/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Try_Again_ButtonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const try_again_button = /** @type {((inputs?: Try_Again_ButtonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Again_ButtonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_try_again_button(inputs)
	return en_try_again_button(inputs)
});